/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import EditIcon from "components/RevampFeedDetails/assets/EditIcon";
import {
	SECTION_MAP,
	SUB_SECTION_MAP,
} from "modules/candidate/profile/constants/sectionConstants";
import { trackOnMixpanel } from "modules/candidate/profile/utils/MixpanelHelper";
import React, { useEffect } from "react";

const checkValidArray = (value) => {
	if (Array.isArray(value) && value.length > 0) return true;
	return false;
};

const EditPreferencesCard = ({ jobDetails, isJobFeedPage }) => {
	useEffect(() => {
		trackOnMixpanel("Edit job preferences screen shown web", {
			source: isJobFeedPage ? "Job Feed Web" : "Job Feed Search",
		});
		trackOnMixpanel("Edit preferred role screen shown web", {
			source: isJobFeedPage ? "Job Feed Web" : "Job Feed Search",
		});
	}, []);
	const getJobPreferences = () => {
		const arr = [];

		if (
			checkValidArray(
				jobDetails?.[SECTION_MAP.JOB_DETAILS]?.[
					SUB_SECTION_MAP.JOB_PREFERENCES.sectionName
				]?.preferredEmploymentType
			)
		) {
			jobDetails?.[SECTION_MAP.JOB_DETAILS]?.[
				SUB_SECTION_MAP.JOB_PREFERENCES.sectionName
			]?.preferredEmploymentType.forEach((type: string) => arr.push(type));
		}
		if (
			checkValidArray(
				jobDetails?.[SECTION_MAP.JOB_DETAILS]?.[
					SUB_SECTION_MAP.JOB_PREFERENCES.sectionName
				]?.preferredShift
			)
		) {
			jobDetails?.[SECTION_MAP.JOB_DETAILS]?.[
				SUB_SECTION_MAP.JOB_PREFERENCES.sectionName
			]?.preferredShift.forEach((type) => arr.push(type));
		}
		if (
			checkValidArray(
				jobDetails?.[SECTION_MAP.JOB_DETAILS]?.[
					SUB_SECTION_MAP.JOB_PREFERENCES.sectionName
				]?.preferredWorkplace
			)
		) {
			jobDetails?.[SECTION_MAP.JOB_DETAILS]?.[
				SUB_SECTION_MAP.JOB_PREFERENCES.sectionName
			]?.preferredWorkplace.forEach((type) => arr.push(type));
		}
		return arr;
	};

	const getPreferredJobTypes = () => {
		const arr = [];
		if (
			checkValidArray(
				jobDetails?.[SECTION_MAP.JOB_DETAILS]?.[
					SUB_SECTION_MAP.PREFERRED_JOB_TITLE.sectionName
				]?.preferredJobTitle
			)
		) {
			jobDetails?.[SECTION_MAP.JOB_DETAILS]?.[
				SUB_SECTION_MAP.PREFERRED_JOB_TITLE.sectionName
			]?.preferredJobTitle.forEach((item) => arr.push(item?.name));
		}
		return arr;
	};
	const handleEditPreferences = () => {
		trackOnMixpanel("Edit job preference clicked web", {
			source: isJobFeedPage ? "Job Feed Web" : "Job Feed Search",
		});
		window.open(
			"/profile?profileInteraction=%7B%22editorOpened%22%3A%22edit_job_preference%22%7D",
			"_self"
		);
	};
	const handleEditTitleRole = () => {
		trackOnMixpanel("Edit Preferred role clicked web", {
			source: isJobFeedPage ? "Job Feed Web" : "Job Feed Search",
		});
		window.open(
			"/profile?profileInteraction=%7B%22editorOpened%22%3A%22add_preferred_job_title%22%7D",
			"_self"
		);
	};
	// Revamp-todo: Add onClick handling to edit buttons
	return (
		<div className="space-y-[16px] rounded-xl bg-white p-[16px]">
			<div>
				<p className="m-0 text-md font-semibold leading-[24px]">
					Edit your preferences
				</p>
				<p className="m-0 text-xs leading-[16px] text-[#8C8594]">
					Your personalised job feed is shown based on these preferences
				</p>
			</div>
			<div className="space-y-[8px]">
				<div className="flex items-center justify-between">
					<p className="m-0 text-sm leading-[20px] text-[#190A28]">
						Preferred title/role
					</p>
					<div
						className="flex cursor-pointer items-center gap-[4px]"
						onClick={handleEditTitleRole}
					>
						<EditIcon />
						<p className="m-0 text-xs font-semibold leading-[16px] text-[#1F8268]">
							Edit
						</p>
					</div>
				</div>
				<div className="flex flex-wrap items-center gap-[4px]">
					{getPreferredJobTypes()?.map((item) => (
						<p className="m-0 w-max rounded-3xl bg-[#F4F2F6] p-[4px] px-[12px] text-sm leading-[20px]">
							{item}
						</p>
					))}
				</div>
			</div>
			<div className="space-y-[8px]">
				<div className="flex items-center justify-between">
					<p className="m-0 text-sm leading-[20px] text-[#190A28]">
						Job preferences
					</p>
					<div
						className="flex cursor-pointer items-center gap-[4px]"
						onClick={handleEditPreferences}
					>
						<EditIcon />
						<p className="m-0 text-xs font-semibold leading-[16px] text-[#1F8268]">
							Edit
						</p>
					</div>
				</div>
				<div className="flex flex-wrap items-center gap-[4px]">
					{getJobPreferences().map((item) => (
						<p className="m-0 w-max rounded-3xl bg-[#F4F2F6] p-[4px] px-[12px] text-sm leading-[20px]">
							{item}
						</p>
					))}
				</div>
			</div>
		</div>
	);
};

export default EditPreferencesCard;
